
const digest = 'afd2483563e7f30e8bf85509870f1e35db629edb5fe541fc7e5383cbda5a19c8';
const classes = {"displayInRow":"_displayInRow_1s233_1","text":"_text_1s233_4","skCircle":"_sk-circle_1s233_10"};
const css = `._displayInRow_1s233_1 {
  display: flex;
}
._displayInRow_1s233_1 ._text_1s233_4 {
  margin-left: 15px;
  margin-top: 0;
  display: flex;
  align-items: center;
}
._displayInRow_1s233_1 ._sk-circle_1s233_10 {
  width: 30px;
  height: 30px;
}

._text_1s233_4 {
  margin-top: 15px;
  font-weight: 500;
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  